module.exports = __webpack_public_path__ + "static/media/logo.7349d83e.png";